export default function ($http) {
    return function (referenceNumber) {
        return $http({
            method: 'GET',
            url: '/api/scannedLetter/download',
            params: {
                referenceNumber
            }
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/services/letters/getScannedLetter.js